type Titled = {
	title?: string | null;
	originalTitle?: string | null;
	alternativeTitles?: Array<string | null> | null;
	legacyTitles?: Array<string | null> | null;
};

/** Все названия сущности для поиска: основное, оригинал и альтернативные из других переводов */
export function getAllTitles(entity: Titled): string[] {
	return [
		entity.title,
		entity.originalTitle,
		...(entity.alternativeTitles || []),
		...(entity.legacyTitles || []),
	].filter(Boolean) as string[];
}
